import { render } from "./prompts.vue?vue&type=template&id=42e6be42&lang=pug"
import script from "./prompts.vue?vue&type=script&lang=js"
export * from "./prompts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__